module.exports = __webpack_public_path__ + "static/assets/89a8b5301a7935918b0e312790d28017.png";